import FormattedMessage from 'I18n/components/FormattedMessage';
import ValidationLabelIcon from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationLabelIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITag from 'UIComponents/tag/UITag';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BranchAccordion = ({
  branchName,
  children,
  iconStyle = 'DEFERRED',
  isAcceptedBranch = false
}) => {
  const getIconStatus = () => {
    if (isAcceptedBranch || iconStyle === 'ACCEPTED') {
      return 'PASSED';
    } else if (iconStyle === 'REJECTED') {
      return 'FAILED';
    }
    return 'NOT_APPLICABLE';
  };
  return /*#__PURE__*/_jsx(AccordionItem, {
    defaultOpen: isAcceptedBranch,
    title: /*#__PURE__*/_jsxs(UIFlex, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-right-2",
        children: /*#__PURE__*/_jsx(ValidationLabelIcon, {
          status: getIconStatus()
        })
      }), branchName, isAcceptedBranch && /*#__PURE__*/_jsx(UITag, {
        className: "m-left-2",
        use: "success",
        inline: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.testV2.simulatePanel.branch.continues"
        })
      })]
    }),
    children: children
  });
};
export default BranchAccordion;